
<template>
  <div >
    <div class="wrapper">
      <parallax
          class="section page-header header-filter heights"
          :style="headerStyle"
      ></parallax>
      <div class="main main-raised" style="background-color: ivory">
        <div class="section profile-content" style="padding:10px 0 !important;">
          <div class="container">
        <Preloader v-if="!user"></Preloader>
        <div v-if="user">
          <h3>Личный кабинет пользователя {{user.name}}</h3>
          <div class="ml-layout">
            <div class="ml-layout-item">
              <nav-tabs-card no-label>
                <template slot="content">

                  <md-tabs class="md-warning" style="padding:2px !important;" md-alignment="left" >
                    <md-tab  v-for="(content, key) in contents" :key="key" :id="content.id"
                            :md-label="content.label" :md-icon="content.icon">

                      <user @getColorantSystem = "colorantSystem = $event" v-if="key === 'user'" :user="user"></user>
                      <change-password v-if="key === 'changePassword'"/>

                      <user-colorants v-if="user.old_colorants && key === 'colorants'"
                                      :colorants="systemColorants" :systemColorants = "colorantSystem"/>

                      <user-products v-if="user.product && key === 'products'" :products="user.product"/>

                    </md-tab>
                  </md-tabs>
                </template>
              </nav-tabs-card>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {mapActions, mapGetters} from "vuex";
import User from "./components/account/User";
import { NavTabsCard } from "@/components";
import ChangePassword from "./components/account/ChangePasword";
import UserColorants from "./components/account/UserColorants";
import UserProducts from "./components/account/UserProducts";
import Preloader from "./components/Preloader";
import router from "../router";

export default {
  name: 'Account',
  components: {Preloader, UserProducts, UserColorants, ChangePassword, User, NavTabsCard},
  data() {
    return {
      colorantSystem: 'old_colorants',
      contents: {
        user: {
          id: 'tab-user',
          label: 'Профиль',
          icon: 'person'
        },
        colorants: {
          id: 'tab-colorants',
          label: 'Колоранты',
          icon: 'color_lens'
        },
        products: {
          id: 'tab-products',
          label: 'Продукты',
          icon: 'local_drink'
        },
        changePassword: {
          id: 'tab-change-password',
          label: 'Сменить пароль',
          icon: 'vpn_key'
        }
      },
    }
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg3.jpg")
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/getUser'
    }),
    signupImage() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    systemColorants(){
      if (this.colorantSystem === 'old_colorants') {
        return this.user.old_colorants;
      }
      return this.user.new_colorants;
    }
  },
  methods: {
    ...mapActions({
      loadUser: 'account/user',
      exit: 'auth/logout'
    })
  },
  created() {
   this.loadUser();
  },
  updated() {
    if (!localStorage.getItem('token')){
      router.push({ name: "auth"})
    }
  }
}
</script>

<style>
.heights {
  height: 200px !important;
}

</style>